import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/linerActivity/private/LinerMessageActivity.module_built.css";
const classes = {"liner-message-activity":"wQVQNzG_liner-message-activity","liner-message-activity__text":"wQVQNzG_liner-message-activity__text"}
export default classes

const _liner_message_activity0 = classes["liner-message-activity"]
export { _liner_message_activity0 as "liner-message-activity" }

const _liner_message_activity__text0 = classes["liner-message-activity__text"]
export { _liner_message_activity__text0 as "liner-message-activity__text" }
